<div class="h-full flex-auto overflow-y-auto lg:pr-2 lg:pl-0">
    <div
        class="min-h-full p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
        <form [formGroup]="cofigurationForm">
        <div class="flex items-center justify-between">
            <h2 class="heading">
                Configuration Information
            </h2>
            <span [ngClass]="companyData?.isActive ? 'badge-success' : 'badge-danger'">
                {{ companyData?.isActive ? 'Active' : 'Inactive' }}
            </span>
        </div>
        
        <p class="text-sm-light">
            (Read Only)
        </p>
            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">

                <div class="space-y-1">
                    <label class="subheading">
                        Reference
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="reference" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button [disabled]="companyData?.isApproved" (click)="setControls('','reference', false)"
                                [ngClass]="{'btn btn-danger': !configVerificationForm.get('reference')?.value,
                        'btn-outline btn-outline-danger': configVerificationForm.get('reference')?.value,
                        'opacity-50 cursor-not-allowed': companyData?.isApproved
                    }" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button [disabled]="companyData?.isApproved" (click)="setControls('','reference', true)"
                                [ngClass]="{'btn btn-success': configVerificationForm.get('reference')?.value,
                        'btn-outline btn-outline-success ': !configVerificationForm.get('reference')?.value,
                        'opacity-50 cursor-not-allowed': companyData?.isApproved}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        General Url
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="generalUrl" type="tel" value="814 718 0908" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button [disabled]="companyData?.isApproved" (click)="setControls('','generalUrl', false)"
                                [ngClass]="{'btn btn-danger': !configVerificationForm.get('generalUrl')?.value,
                                       'btn-outline btn-outline-danger': configVerificationForm.get('generalUrl')?.value,
                                       'opacity-50 cursor-not-allowed': companyData?.isApproved
                                    }" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button [disabled]="companyData?.isApproved" (click)="setControls('','generalUrl', true)"
                                [ngClass]="{'btn btn-success': configVerificationForm.get('generalUrl')?.value,
                            'btn-outline btn-outline-success ': !configVerificationForm.get('generalUrl')?.value,
                            'opacity-50 cursor-not-allowed': companyData?.isApproved
                        }" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Trip Url
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="tripUrl" type="tel" value="814 718 0908" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button [disabled]="companyData?.isApproved" (click)="setControls('','tripUrl', false)"
                                [ngClass]="{'btn btn-danger': !configVerificationForm.get('tripUrl')?.value,
                                       'btn-outline btn-outline-danger': configVerificationForm.get('tripUrl')?.value,
                                       'opacity-50 cursor-not-allowed': companyData?.isApproved
                                    }" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button [disabled]="companyData?.isApproved" (click)="setControls('','tripUrl', true)"
                                [ngClass]="{'btn btn-success': configVerificationForm.get('tripUrl')?.value,
                            'btn-outline btn-outline-success ': !configVerificationForm.get('tripUrl')?.value,
                            'opacity-50 cursor-not-allowed': companyData?.isApproved
                        }" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Vehicle Url
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="vehicleUrl" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button [disabled]="companyData?.isApproved" (click)="setControls('','vehicleUrl', false)"
                                [ngClass]="{'btn btn-danger': !configVerificationForm.get('vehicleUrl')?.value,
                        'btn-outline btn-outline-danger': configVerificationForm.get('vehicleUrl')?.value,
                        'opacity-50 cursor-not-allowed': companyData?.isApproved
                    }" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button [disabled]="companyData?.isApproved" (click)="setControls('','vehicleUrl', true)"
                                [ngClass]="{'btn btn-success': configVerificationForm.get('vehicleUrl')?.value,
                        'btn-outline btn-outline-success ': !configVerificationForm.get('vehicleUrl')?.value,
                        'opacity-50 cursor-not-allowed': companyData?.isApproved}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        Driver Url
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="driverUrl" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button [disabled]="companyData?.isApproved" (click)="setControls('','driverUrl', false)"
                                [ngClass]="{'btn btn-danger': !configVerificationForm.get('driverUrl')?.value,
                                    'btn-outline btn-outline-danger': configVerificationForm.get('driverUrl')?.value,
                                    'opacity-50 cursor-not-allowed': companyData?.isApproved
                                }" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button [disabled]="companyData?.isApproved" (click)="setControls('','driverUrl', true)"
                                [ngClass]="{'btn btn-success': configVerificationForm.get('driverUrl')?.value,
                                    'btn-outline btn-outline-success ': !configVerificationForm.get('driverUrl')?.value,
                                    'opacity-50 cursor-not-allowed': companyData?.isApproved}" class="px-2"
                                type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

          


            </section>
        </form>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section *ngIf="checkNonValidFields().length && getInvalidFields().length"
            class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <div class="space-y-4 col-span-full">

                <details class="rounded-lg p-6 ring-2 ring-red-600 bg-red-600/5" open>
                    <summary class="heading">The following information is invalid and needs to be resubmitted by the
                        company.
                    </summary>
                    <div class="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-400">
                        <div class="flex flex-wrap gap-2">
                            <ng-container *ngFor="let field of getInvalidFields()">
                                <div class="badge-danger border border-red-600/10">
                                    {{field}}
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </details>
                <div class="flex justify-end">
                    <button class="btn btn-primary" (click)="sendInvalidFieldsViaEmail()">
                        Send Information via Email
                    </button>
                </div>
            </div>
        </section>
        <div>
            <form [formGroup]="approvalForm" (ngSubmit)="onApproval()">
                <!-- *ngIf="isAllControlsTrue" -->
                <ng-container
                    *ngIf="!checkNonValidFields().length || (companyData?.isApproved && checkNonValidFields().length)">

                    <div class="mt-4">
                        <h2 class="subheading">
                            I have checked the information given, and I hereby confirm that all data
                            entered is
                            valid and
                            satisfactory for the purpose of compliance and billing of trips.
                        </h2>
                    </div>

                    <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                    <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3" *ngIf="companyData && companyData.validationFlags">

                        <!-- Date -->
                        <div class="space-y-1">
                            <label class="subheading">
                                Date
                            </label>
                            <div class="flex flex-1 gap-2">
                                <div class="flex-1">
                                    <input type="text" name="time" id="time" formControlName="approvedDate"
                                        [owlDateTime]="approvedDate" [owlDateTimeTrigger]="approvedDate" [readOnly]="true" />
                                    <owl-date-time [pickerType]="'calendar'"
                                        (afterPickerClosed)="onDateChange(approveForm.approvedDate)"
                                        #approvedDate></owl-date-time>
                                </div>
                            </div>
                            <div *ngIf="submitted && approveForm.approvedDate.errors">
                                <p *ngIf="approveForm.approvedDate.errors.required" class="pt-1 text-red-600 text-xs">
                                    Date is required
                                </p>
                            </div>
                        </div>
                    </section>

                </ng-container>

                <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                <section class="flex justify-end gap-4">
                    <button
                        *ngIf="companyData && (!companyData?.validationFlags || (!companyData?.isApproved && checkNonValidFields().length))"
                        type="button" (click)="onSave()" class="btn-outline btn-outline-secondary">
                        Save
                    </button>
                
                    <button
                        *ngIf="(companyData?.validationFlags && !checkNonValidFields().length)|| (companyData?.isApproved && checkNonValidFields().length)"
                        type="submit" class="btn-outline btn-outline-secondary">
                        {{companyData?.isApproved ? 'Unapprove' : 'Approve'}}
                    </button>
                </section>
            </form>
        </div>
    </div>
</div>